import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shenhe",
  "use": "icon-shenhe-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shenhe\"><path d=\"M640 312H200c-22 0-40-18-40-40s18-40 40-40h440c22 0 40 18 40 40s-18 40-40 40zM640 552H200c-22 0-40-18-40-40s18-40 40-40h440c22 0 40 18 40 40s-18 40-40 40zM520.6 792H200c-22 0-40-18-40-40s18-40 40-40h320.6c22 0 40 18 40 40s-17.8 40-40 40zM120 944c-22 0-40-18-40-40V120c0-22 18-40 40-40h600c22 0 40 18 40 40v352h80V120c0-66.2-53.8-120-120-120H120C53.8 0 0 53.8 0 120v784c0 66.2 53.8 120 120 120h352v-80H120zM472 984m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0ZM800 472m-40 0a40 40 0 1 0 80 0 40 40 0 1 0-80 0ZM602.8 1024H992c25.8 0 32-5 32-20.4V950c0-9.4-7.2-17.2-16.2-17.2h-86c-77.6-80.6-34.6-72-5.4-122.6 5.4-7 10.6-14 14.6-22.4 12-22.4 18.6-47.8 18.6-75.8 0-87.2-66.4-158.8-150-158.8-82.2 0-150 70.2-150 158.8 0 36.6 12 70.2 31.8 97 31.8 53.4 83.6 55.2 0 124h-80c-12.2 0-22.2 10.6-22.2 23.4v48.2c0.2 9.4 8.2 19.4 23.6 19.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shenhe.svg
// module id = T0Hs
// module chunks = 12